var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusRounded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4995 0C4.70948 0 0 4.67052 0 10.4126C0 16.1547 4.70948 20.8263 10.4995 20.8263C16.2895 20.8263 21 16.1547 21 10.4126C21 4.67052 16.2895 0 10.4995 0ZM10.4995 19.9931C5.1741 19.9931 0.84018 15.695 0.84018 10.4137C0.84018 5.13236 5.1741 0.833225 10.4995 0.833225C15.8249 0.833225 20.1609 5.13023 20.1609 10.4137C20.1609 15.6972 15.827 19.9931 10.4995 19.9931Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1641 10.4138C17.1641 10.982 16.6994 11.4428 16.1254 11.4428H4.87158C4.29752 11.4428 3.83398 10.982 3.83398 10.4138C3.83398 9.84554 4.29752 9.38477 4.87158 9.38477H16.1254C16.6994 9.38477 17.1641 9.84554 17.1641 10.4138Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5005 3.80273C11.0746 3.80273 11.5381 4.26351 11.5381 4.83283V15.9936C11.5381 16.5629 11.0746 17.0226 10.5005 17.0226C9.9275 17.0226 9.46289 16.5639 9.46289 15.9936V4.83283C9.46289 4.26351 9.9275 3.80273 10.5005 3.80273Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusRounded);
export default __webpack_public_path__ + "static/media/plus-rounded.e5022005f49cfcbf2e05a5267951d8dd.svg";
export { ForwardRef as ReactComponent };